"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    //The maximum is exclusive and the minimum is inclusive
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
exports.getRandomInt = getRandomInt;
function getRandomArrayItem(_a) {
    var array = _a.array, _b = _a.start, start = _b === void 0 ? 0 : _b;
    var randomIndex = getRandomInt(start, array.length - 1);
    return array[randomIndex];
}
exports.getRandomArrayItem = getRandomArrayItem;
function getRandomEnumEntry(_a) {
    var en = _a.en, _b = _a.start, start = _b === void 0 ? 0 : _b;
    var enumKeys = Object.keys(en)
        .map(function (n) { return Number.parseInt(n); })
        .filter(function (n) { return !Number.isNaN(n); });
    var randomIndex = getRandomArrayItem({
        array: enumKeys,
        start: start
    });
    return en[randomIndex];
}
exports.getRandomEnumEntry = getRandomEnumEntry;
